import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";


class Activar extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setData(data) {
        this.setState({
            valor: data.value
        })
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.coeficientesue.activar}
                postUrl={api.proyectos.config.presupuesto.coeficientesue.activar}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Coeficiente UE ha sido editado con éxito."}
                title={"Actualizar Coeficiente UE a Vigente"}
                buttonTitle={"Actualizar Coeficiente UE a Vigente"}
                buttonIcon={"fa fa-check fa-lg"}
                saveButtonLabel={"Activar"}
                saveButton={true}
                closeButton={true}
                buttonClass={"btn-success btn-next"}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setData(data)}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Coeficiente a activar</p>
                        <div className="ui-alert ui-alert-success">
                            <i className="ti ti-check" aria-hidden="true"></i>
                            <span>El coeficiente seleccionado pasará a estar vigente.</span>
                        </div>
                        <ParadigmaLabeledInput disabled fieldName="nombre" label="Nombre" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput disabled type={"number"} fieldName="valor" label="Valor" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput disabled type={"textarea"} fieldName="descripcion" label="Descripción" labelColumns={12} fieldColumns={12} />
                    </section>
                </div>

            </ParadigmaModal>
        );
    }
}

export default Activar;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_CoeficientesUE/Activar.js